import { baseApi } from './baseApi';

export const TAG_ATTENTION_CENTER = 'AttentionCenter';

/**
 * GET /api/v1/medapp/attention-center/?language=pl|en
 */
const attentionCenterApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAttentionCenter: builder.query({
      query: (language = 'pl') => {
        const params = new URLSearchParams({ language });
        return {
          url: `/medapp/attention-center/?${params.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response) => response?.attention_center ?? null,
      providesTags: (result, error, language) => [
        { type: TAG_ATTENTION_CENTER, id: language ?? 'pl' },
      ],
    }),
  }),
});

export const { useFetchAttentionCenterQuery } = attentionCenterApi;
